import { render } from "./CardSet.vue?vue&type=template&id=72d0ff80&scoped=true"
import script from "./CardSet.vue?vue&type=script&lang=js"
export * from "./CardSet.vue?vue&type=script&lang=js"

import "./CardSet.vue?vue&type=style&index=0&id=72d0ff80&lang=scss"
import "./CardSet.vue?vue&type=style&index=1&id=72d0ff80&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\floresn\\source\\repos\\igx-vue-park-list\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72d0ff80"]])

export default __exports__